import React from 'react'
import * as Auth from '@morningtrain/react-auth'
import { LogoutPipeline } from '@morningtrain/react-auth'
import MenuItem from 'widgets/navigation/MenuItem'
import SidebarMenuItem from 'ui/navigation/SidebarMenuItem'
import LocaleSwitcher from 'widgets/localization/LocaleSwitcher'
import { Translation } from '@morningtrain/react-translations'
import * as Icons from 'ui/icons'
import Permissions from 'services/Permissions'
import AdminMainNavigationInner from 'widgets/navigation/AdminMainNavigationInner'
import EmployeeMainNavigationInner from 'widgets/navigation/EmployeeMainNavigationInner'
import { WhenEnvValueMatches } from '@morningtrain/react-helpers'

export default function AdminMainNavigation () {
  return (
    <>
      <nav className='pt-8 flex-1 bg-white'>
        <div className='space-y-2'>

          <WhenEnvValueMatches name='user.is_trial' matches={false}>
            <Auth.Can permission={Permissions.VIEW_ADMIN_MENU}>
              <AdminMainNavigationInner />
            </Auth.Can>
            <Auth.Can permission={Permissions.VIEW_ADMIN_MENU} negate>
              <EmployeeMainNavigationInner />
            </Auth.Can>
          </WhenEnvValueMatches>

        </div>
      </nav>

      <div className='mt-6'>
        <LocaleSwitcher />
      </div>

      <div className='mt-6'>
        <WhenEnvValueMatches name='user.is_trial' matches={false}>
          <MenuItem
            route='app.hr.salary.personal'
            label={<Translation name='hr.salary.personal.title' />}
            svgIcon={<Icons.Salary />}
          />
        </WhenEnvValueMatches>
        <MenuItem
          route='app.users.profile'
          label={<Translation name='profile.title' />}
          svgIcon={<Icons.Users />}
        />
      </div>

      <nav>
        <div className='mt-6 mb-4 border-t border-gray-200 mx-8' />
        <LogoutPipeline>
          <a>
            <SidebarMenuItem
              text={<Translation name='auth.actions.logout' />}
              svgIcon={<Icons.Logout />}
            />
          </a>
        </LogoutPipeline>
      </nav>
    </>
  )
}
